import { ThemeProvider } from "@emotion/react";
import { createTheme, CssBaseline } from "@mui/material";
import BrowserApp from "./BrowserApp/BrowserApp";
import MediaQuery from "react-responsive";
import MobileApp from "./MobileApp/MobileApp";

const myTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#B3C6CB',
      contrastText: 'rgba(255,253,253,0.87)',
    },
    secondary: {
      main: '#D9D1C0',
    },
    text: {
      primary: 'rgba(0,0,0,0.87)',
      secondary: 'rgba(0,0,0,0.54)',
    },
  },
});

const MOBILE_WIDTH = 1224;

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={myTheme}>
        <CssBaseline />
        <MediaQuery minWidth={MOBILE_WIDTH}>
          <BrowserApp />
        </MediaQuery>
        <MediaQuery maxWidth={MOBILE_WIDTH}>
          <MobileApp />
        </MediaQuery>
      </ThemeProvider>
    </div>
  );
}

export default App;
